import React from "react";
import { buildStyles, CircularProgressbarWithChildren } from "react-circular-progressbar";
import styles from "./percent-circular-progress.module.scss";
import { Icon } from "../icons/icon";

interface IPercentCircularProgressProps {
    label?: string;
    percent: number;
}

export const PercentCircularProgress: React.FC<IPercentCircularProgressProps> = ({
                                                                                     label,
                                                                                     percent
                                                                                 }) => (
    <Icon title={label} className={styles.icon}>
        <div className={styles.circularContainer}>
            <CircularProgressbarWithChildren value={percent} styles={buildStyles({
                rotation: 0,
                strokeLinecap: "butt",
                textSize: "7px",
                pathTransitionDuration: 0.5,
                pathColor: `rgba(62, 152, 199, ${45 / 100})`,
                textColor: `rgba(62, 152, 199, ${45 / 100})`,
                trailColor: "#d6d6d6",
                backgroundColor: `rgba(62, 152, 199, ${45 / 100})`
            })}>
                <div className={styles.processChild}>
                    <strong>{percent}%</strong>
                </div>
            </CircularProgressbarWithChildren>
        </div>
    </Icon>
);
